import { __assign, __rest } from "tslib";
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { ArtBrandedDesktopPopup } from '../../ArtBrandedPopup';
import Button from '../../Button';
import VerificationEmailInput from '../../VerificationEmailInput';
import { useFlag } from '../../redux/flags/hooks';
import s from './VerificationPopupDesktop.scss';
export var VerificationPopupDesktop = function (_a) {
    var actionType = _a.actionType, email = _a.email, resendEmail = _a.resendEmail, onClose = _a.onClose, isSendingDone = _a.isSendingDone, props = __rest(_a, ["actionType", "email", "resendEmail", "onClose", "isSendingDone"]);
    var t = useTranslation().t;
    var modalType = actionType ? 'action' : 'welcome';
    var title = t("verification.title." + modalType, {
        action: t("verification.action." + actionType),
    });
    var tagline = t("verification.tagline." + modalType);
    var verificationFlowV2 = useFlag('email_verification_flow_v2');
    var hasResentEmail = verificationFlowV2 && isSendingDone;
    return (React.createElement(ArtBrandedDesktopPopup, __assign({ artImageSrc: Url.staticCDNLink('eclipse/sisu/image-11-620625097.jpg'), artAuthorUsername: 'AxiomDesign', title: title, tagline: tagline, className: classnames(s[modalType + "-modal"]), titleClassName: s['title'], taglineClassName: s['tagline'], contentClassName: s['content'], popupProps: { isOpen: true }, onClose: onClose }, props),
        React.createElement("div", { className: s['text'] },
            React.createElement(Trans, { i18nKey: "verification.checkEmail." + modalType },
                React.createElement("span", { className: s['email'] }, { email: email }))),
        React.createElement("div", { className: s['text'] }, t("verification.instructions." + modalType)),
        React.createElement("div", { className: s['buttons'] },
            React.createElement(Button, { view: "b3", height: "medium", className: s['button'], onClick: function () {
                    resendEmail();
                    // don't close modal if v2
                    !verificationFlowV2 && onClose && onClose();
                }, disabled: hasResentEmail }, hasResentEmail
                ? t('verification.emailSent')
                : t('verification.resend')),
            React.createElement("div", { className: s['change-email'] },
                React.createElement(Trans, { i18nKey: "verification.notEmail" },
                    React.createElement("span", { className: s['email'] }, { email: email })),
                React.createElement(VerificationEmailInput, { className: s['change-email-input'] })))));
};
VerificationPopupDesktop.displayName = 'VerificationPopupDesktop';
export default VerificationPopupDesktop;
//# sourceMappingURL=VerificationPopupDesktop.js.map